<div class="topbar-wrapp color-scheme-light">
  <div class="container topbar-content">
    <div class="top-bar-left">
      <div class="topbar-text">
        <i class="icon-phone"></i>
        OUR PHONE NUMBER:
        <a [href]="topbarPhoneHref">{{ topbarPhone }}</a>
      </div>
    </div>
  </div>
</div>

<header class="main-header header-simple">
  <div class="container">
    <div class="wrapp-header">
      <ng-container *ngTemplateOutlet="logoTpl" />
      <ng-container *ngTemplateOutlet="navTpl" />
      <ng-container *ngTemplateOutlet="rightTpl" />
    </div>
  </div>
</header>

<div class="sticky-header header-clone header-simple" [class.act-scroll]="scrolled()">
  <div class="container">
    <div class="wrapp-header">
      <ng-container *ngTemplateOutlet="logoTpl" />
      <ng-container *ngTemplateOutlet="navTpl" />
      <ng-container *ngTemplateOutlet="rightTpl" />
    </div>
  </div>
</div>

<div class="mobile-nav">
  <ul>
    @for (link of nav(); track link.label) {
      <li [class.current-menu-item]="isCurrent(link)">
        <a [routerLink]="link.path" [queryParams]="link.query ?? null" (click)="closeMenu()">{{
          link.label
        }}</a>
        @if (link.children?.length) {
          <ul class="sub-menu">
            @for (child of link.children; track child.label) {
              <li>
                <a
                  [routerLink]="child.path"
                  [queryParams]="child.query ?? null"
                  (click)="closeMenu()"
                  >{{ child.label }}</a
                >
              </li>
            }
          </ul>
        }
      </li>
    }
  </ul>
</div>

<div class="search-button basel-search-full-screen">
  <div class="basel-search-wrapper" [class.search-overlap]="overlay.searchOpen()">
    <div class="basel-search-inner">
      <span class="basel-close-search" (click)="overlay.closeSearch()">close</span>
      <form class="searchform" role="search" (submit)="submitSearch($event)">
        <input
          type="text"
          placeholder="Search for products"
          [value]="searchQuery()"
          (input)="onSearchInput($event)"
        />
        <button type="submit">Search</button>
      </form>
      @if (searchResults().length) {
        <div class="autocomplete-suggestions">
          @for (item of searchResults(); track item.id) {
            <a
              class="autocomplete-suggestion"
              [routerLink]="['/product', item.slug]"
              (click)="overlay.closeSearch()"
            >
              <span class="suggestion-thumb"
                ><img [src]="item.imageUrl" [alt]="item.name"
              /></span>
              <span class="suggestion-title">{{ item.name }}</span>
              <span class="suggestion-price">
                <span class="woocommerce-Price-amount amount">
                  <span class="woocommerce-Price-currencySymbol">$</span
                  >{{ item.price | number: '1.2-2' }}
                </span>
              </span>
            </a>
          }
        </div>
      }
    </div>
  </div>
</div>

<ng-template #logoTpl>
  <div class="site-logo">
    <a routerLink="/" rel="home">
      <img [src]="logo" [alt]="displayName" />
    </a>
  </div>
</ng-template>

<ng-template #navTpl>
  <div class="main-nav site-navigation basel-navigation menu-main-menu menu-center" role="navigation">
    <ul class="menu">
      @for (link of nav(); track link.label) {
        @if (link.children?.length) {
          <li
            class="menu-item menu-item-has-children item-event-hover menu-item-design-default"
            [class.current-menu-item]="isCurrent(link)"
          >
            <a [routerLink]="link.path" [queryParams]="link.query ?? null">{{ link.label }}</a>
            <div class="sub-menu-dropdown">
              <ul class="sub-menu">
                @for (child of link.children; track child.label) {
                  <li>
                    <a [routerLink]="child.path" [queryParams]="child.query ?? null">{{ child.label }}</a>
                  </li>
                }
              </ul>
            </div>
          </li>
        } @else {
          <li
            class="menu-item item-event-hover menu-item-design-default"
            [class.current-menu-item]="isCurrent(link)"
          >
            <a [routerLink]="link.path" [queryParams]="link.query ?? null">{{ link.label }}</a>
          </li>
        }
      }
    </ul>
  </div>
</ng-template>

<ng-template #rightTpl>
  <div class="right-column">
    @if (!isAdminLoggedIn()) {
      <div class="search-button">
        <a href="#" (click)="openSearch($event)"><i></i></a>
      </div>
    }
    @if (isAdminLoggedIn()) {
      <div class="portal-session">
        <div class="portal-admin-actions">
          <app-admin-chat-notifier />
          <a
            class="portal-admin-btn"
            routerLink="/admin"
            aria-label="Admin"
            title="Admin"
          >
            <span class="material-symbols-outlined" aria-hidden="true">admin_panel_settings</span>
          </a>
          <button
            type="button"
            class="portal-admin-btn"
            (click)="logout()"
            aria-label="Logout"
            title="Logout"
          >
            <span class="material-symbols-outlined" aria-hidden="true">logout</span>
          </button>
        </div>
        @if (user(); as current) {
          <div class="portal-user-block">
            <div class="portal-user-copy">
              <p class="portal-user-name">{{ current.name }}</p>
              <p class="portal-user-role">{{ roleKey(current.role) | t }}</p>
            </div>
            <span class="portal-user-avatar" aria-hidden="true">
              {{ current.name.charAt(0).toUpperCase() }}
            </span>
          </div>
        }
      </div>
    } @else {
      <div class="shopping-cart basel-cart-design-2">
        <a href="#" (click)="openCart($event)">
          <span>Cart</span>
          @if (cart.itemCount() > 0) {
            <span class="basel-cart-number">{{ cart.itemCount() }}</span>
          }
          @if (cart.itemCount() > 0) {
            <span class="basel-cart-subtotal">{{ cartSubtotal() }}</span>
          }
        </a>
      </div>
    }
    <div class="mobile-nav-icon">
      <a href="#" (click)="openMenu($event)">
        <span class="basel-burger"></span>
      </a>
    </div>
  </div>
</ng-template>
